import React, { Fragment, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom/dist";
import Table from "../../../core/pagination/datatable";
import { ErrorToaster } from "../../components/toaster/Toaster";
import { Debounce, getDate } from "../../../utils";
import CustomerServices from "../../../services/Customer";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import CountUp from "react-countup";
import { all_routes } from "../../../Router/all_routes";
import { PlusCircle } from "feather-icons-react/build/IconComponents";

const CustomerOrders = () => {

  const routes = all_routes;
  const navigate = useNavigate();
  const { id } = useParams()

  // *For Loader
  const [loader, setLoader] = useState(false);

  // *For Orders
  const [customerDetail, setCustomerDetail] = useState();
  const [orders, setOrders] = useState([]);
  const [summary, setSummary] = useState();

  // *For Pagination
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  // *For Filter
  const [filters, setFilters] = useState({});

  // *For Handle Filter
  const handleFilter = (data) => {
    Debounce(() => getOrderReportByCustomer(1, '', data));
  }

  // *For Get Customer Orders
  const getOrderReportByCustomer = async (page, limit, filter) => {
    setLoader(true)
    try {
      const Page = page ? page : currentPage
      const Limit = limit ? limit : pageLimit
      const Filter = { ...filters, ...filter }
      setCurrentPage(Page)
      setPageLimit(Limit)
      setFilters(Filter)
      let params = {
        page: Page,
        limit: Limit
      }
      params = { ...params, ...Filter }
      const result = await CustomerServices.getOrderReportByCustomer(id)
      setCustomerDetail(result?.customer)
      setOrders(result?.orders)
      setSummary(result?.summary)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoader(false)
    }
  }

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      render: (date) => (
        <span>
          {getDate(date)}
        </span>
      )
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      render: (amount) => (
        <span>
          ${parseFloat(amount).toFixed(2)}
        </span>
      )
    },
  ];

  useEffect(() => {
    getOrderReportByCustomer()
  }, []);

  return (
    <Fragment>

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Order List</h4>
              </div>
            </div>
            <div className="page-btn">
              <Link
                to={routes?.createSale}
                state={customerDetail}
                className="btn btn-added"
              >
                <PlusCircle className="me-2" />
                Add New Sale Invoice
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-widget w-100">
                <div className="dash-widgetimg">
                  <span>
                    <ImageWithBasePath
                      src="assets/img/icons/dash1.svg"
                      alt="img"
                    />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    $<CountUp start={0} end={summary?.averageOrder} decimals={2} duration={3} />
                  </h5>
                  <h6>Average Order</h6>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-widget dash1 w-100">
                <div className="dash-widgetimg">
                  <span>
                    <ImageWithBasePath
                      src="assets/img/icons/dash2.svg"
                      alt="img"
                    />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    $
                    <CountUp
                      start={0}
                      end={summary?.totalAmount}
                      decimals={2}
                      duration={3}
                    />
                  </h5>
                  <h6>Total Amount</h6>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-widget dash2 w-100">
                <div className="dash-widgetimg">
                  <span>
                    <ImageWithBasePath
                      src="assets/img/icons/dash3.svg"
                      alt="img"
                    />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    <CountUp
                      start={0}
                      end={summary?.totalOrders}
                      duration={3} // Duration in seconds
                    />
                  </h5>
                  <h6>Total Orders</h6>
                </div>
              </div>
            </div>
          </div>
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                      onChange={(e) => handleFilter({ search: e.target.value })}
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <Table
                  loading={loader}
                  columns={columns}
                  dataSource={orders}
                  totalCount={totalCount}
                  pageSize={pageLimit}
                  currentPage={currentPage}
                  onChange={(page, pageSize) => getOrderReportByCustomer(page, pageSize)}
                  onRow={(obj) => {
                    return {
                      onClick: () => {
                        navigate(`${routes.viewOriginalSaleInvoice}/${obj?.id}`);
                      },
                    };
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CustomerOrders;
